import * as React from 'react';
import {
  motion,
} from 'framer-motion';

import {
  Lang,
  Colors,
  Breakpoint,

  useDimensions,

  LargeContainer,
  ContentContainer,
  Title,
} from '@bluecurrent/web-component-lib';

import Setup from '../../../../config/Setup.config';

import Graph from './Modules/Graph';
import Controls from './Modules/Controls';
import Legenda from './Modules/Legenda';

export default function EnergyPrices(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();

  const ref = React.useRef(null);

  const [width, setWidth] = React.useState('100%');
  const [type, setType] = React.useState('electricity');
  const [chart, setChart] = React.useState('market');
  const [hasVat, setVat] = React.useState(true);

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  const getDimensions = () => {
    if (ref.current.clientWidth !== null) setWidth(ref.current.clientWidth);
  };

  React.useEffect(() => {
    getDimensions();
  }, [width]);

  React.useEffect(() => {
    window.addEventListener('resize', getDimensions);

    return () => window.removeEventListener('resize', getDimensions);
  }, []);

  return (
    <>
      <ContentContainer>
        <motion.div
          ref={ref}
          style={{
            width: '100%',
            minWidth: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: size.width < Breakpoint.md ? 45 : 30,
            paddingBottom: 45,
          }}
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            ease: 'easeInOut',
            stiffness: 100,
          }}
          viewport={{
            once: true,
          }}
        >
          <Title
            fontSize="2.8em"
            textAlign="center"
          >
            { props.data.title[lang] }
          </Title>
        </motion.div>
      </ContentContainer>
      <LargeContainer>
        <motion.div
          style={{
            height: 'auto',
            width: '100%',
            minWidth: 320,
            position: 'relative',
          }}
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            ease: 'easeInOut',
            stiffness: 100,
          }}
          viewport={{
            once: true,
          }}
        >
          <div
            style={{
              height: '60svh',
              maxHeight: 550,
              width: '100%',
              backgroundColor: Colors.GRADIENT,
              borderRadius: size.width < Breakpoint.xxl ? 0 : 15,
              position: 'absolute',
            }}
          />
          <div
            style={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              position: 'relative',
              top: 30,
              gap: 15,
            }}
          >
            <Controls
              width={width}
              type={type}
              chart={chart}
              hasVat={hasVat}
              onSelectElectricity={() => setType('electricity')}
              onSelectGas={() => setType('gas')}
              onSelectChart={(value) => setChart(value)}
              onVat={(boolean) => setVat(boolean)}
            />
            <Graph
              width={width}
              type={type}
              chart={chart}
              hasVat={hasVat}
            />
          </div>
          <Legenda
            width={width}
          />
        </motion.div>
      </LargeContainer>
    </>
  );
}
